export enum Step {
  SquareFootage = 0,
  BrandOrCategory = 1,
  CompareDistanceOrGeography = 2,
  Time = 3,
  ReportName = 4,
}

export enum TabSelection {
  Retail = "Retail",
  Healthcare = "Healthcare",
}

export enum FilterOption {
  Brands = "Brands",
  Category = "Category",
}

export enum CompareOption {
  Neither,
  Closest,
  Geography,
}

export enum GeographyOption {
  DMA = "DMAS",
  State = "STATE",
  CensusRegion = "REGION",
  National = "COUNTRY"
}

export enum ClosestDistanceOption {
  Ten = 10,
  Fifty = 50,
  Hundred = 100,
}
